<template>
    <div>
        <card-header title="Editor" icon="fa-edit"/>

<!--        <card-toolbar>-->
<!--&lt;!&ndash;            <button @click="$openCard('edit-new-component', {componentId: component.id}, card)"><i class="far fa-pencil"></i>Edit Component</button>&ndash;&gt;-->
<!--            &lt;!&ndash;            <button @click="duplicate"><i class="far fa-copy"></i>Duplicate</button>&ndash;&gt;-->
<!--        </card-toolbar>-->

        <card-body class="content p-5">
            <card-container padded>

                <component
                    v-if="component.type"
                    :is="componentType"
                    :component="component"
                />

                <!-- DEBUG -->
                <b-collapse animation="slide" class="mt-6" :open="false">
                    <template #trigger="props">
                        <div role="button" class="collapse-header">
                            <h6 class="has-text-grey is-uppercase is-pulled-left">Debug</h6>
                            <p class="is-pulled-right">
                                <i class="fas" :class="props.open ? 'fa-caret-down' : 'fa-caret-up'"></i>
                            </p>
                            <p class="is-clearfix"></p>
                        </div>
                    </template>

                    <div class="content">
                        <json-viewer :value="component.content" :expand-depth="10" copyable v-if="component.content"></json-viewer>
                    </div>
                </b-collapse>

            </card-container>
        </card-body>

        <card-footer class="pt-3 pb-3 has-text-right">
            <b-button type="is-primary" size="is-small" class="mr-3" @click="save">
                <i class="fas fa-check mr-2"></i>Save
            </b-button>
<!--            <b-button type="" size="is-small" @click="submit">-->
<!--                <i class="fas fa-check mr-2"></i>Close-->
<!--            </b-button>-->
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardContainer from "@/TIER/components/CardContainer";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";

    import {client as http, apiUrl} from '../../http_client';

    const axios = require('axios');
    import {mapGetters} from 'vuex';

    import LessonComponent from "../../components/editor/component_types/LessonComponent.vue";
    import CheckpointComponent from "../../components/editor/component_types/CheckpointComponent.vue";
    import QuizComponent from "../../components/editor/component_types/QuizComponent.vue";
    import SurveyComponent from "../../components/editor/component_types/SurveyComponent.vue";
    import FormComponent from "../../components/editor/component_types/FormComponent.vue";

    let token = null;

    export default {
        components: {CardFooter, CardToolbar, CardContainer, CardBody, CardHeader, LessonComponent, CheckpointComponent, QuizComponent, SurveyComponent, FormComponent},
        props: ['card', 'props', 'child'],
        data() {
            return {
                component: {},
            };
        },
        computed: {
            ...mapGetters(['token']),
            componentType: function() {
                return this.component.type.charAt(0).toUpperCase() + this.component.type.slice(1).toLowerCase() + 'Component';
            }
        },
        methods: {
            loadComponent: function() {
                this.component = {};
                console.log('Clearing Editor Array.');
                window.editors = [];

                if (window.editor && window.editor.destroy) window.editor.destroy();

                this.$emit('loading', true);
                http.get('components/' + this.props.componentId, {force: true}).then(response => {
                    this.component = response.data;

                    this.component.content = JSON.parse(this.component.content);

                    this.$emit('loading', false);

                });
            },
            save() {
                let payload = {...this.component};
                payload.content = JSON.stringify(payload.content);
                http.put('components/' + this.props.componentId, payload, {force: true}).then(response => {
                    this.$saveAlert(false);
                    this.$notify('success', 'Save Complete', 'The component has been saved.', {duration: 3000, permanent: false});
                });
            },
            submit() {
                this.$emit('loading', true);
                window.editor.save().then(saved => {
                    this.component.content = JSON.stringify(saved);
                    http.put('components/' + this.props.componentId, this.component, {force: true}).then(response => {
                        this.$saveAlert(false);
                        this.$closeCard(this.card);
                    });
                });
            },
            // duplicate: function() {
            //     this.$emit('loading', true);
            //     window.editor.save().then(saved => {
            //         this.component.content = JSON.stringify(saved);
            //         http.put('components/' + this.props.componentId, this.component, {force: true}).then(response => {
            //             http.post('components/duplicate', {id: this.component.id}).then(response => {
            //                 this.$reloadCard('components');
            //                 this.$saveAlert(false);
            //                 this.$closeCard(this.card);
            //             });
            //         });
            //     });
            // },
        },
        watch: {
            'props.componentId': function() {
                this.loadComponent();
            }
        },
        mounted: function() {
            this.loadComponent();
            console.log('Editor Mounted. (NewEditor)');
            window.token = this.token; // More global scope for editor posts
        },
        destroyed() {
            // console.log('Editor Destroyed.');
            // delete window.editors;
        }
    };
</script>

<style scoped lang="scss">
    .collapse-header {
        border-bottom: 2px solid #e7e7e7;
        padding-bottom: 0;
        margin-bottom: 20px;

        i {
            padding: 0 10px;
        }
    }
</style>

<style lang="scss">
    .jv-code {
        padding: 0 !important;
    }
</style>
